<template>
  <div
    class="custom-cursor"
    :class="{
      'custom-cursor__reverse': !isLeftToRight,
      'custom-cursor__start': isStartPoint,
    }"
  >
    <div class="custom-cursor__line"></div>
    <div class="custom-cursor__arrowhead">
      <div class="custom-cursor__triangle"></div>
    </div>
  </div>
</template>

<script>
import { CustomCursorTypes } from "../../../../../utils/constants";

export default {
  props: ["isLeftToRight"],
  computed: {
    isStartPoint() {
      return this.$store.state.cells.arrow.activeCursor === CustomCursorTypes.Start;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../../../assets/styles/variables";

.custom-cursor {
  position: relative;
  background-color: @kk-color-primary-blue;
  display: flex;
  &__reverse {
    flex-direction: row-reverse;
  }

  &__line {
    width: 1.2rem;
    background-color: @kk-color-primary-blue;
    height: @kk-arrow-height;
  }
  &__start &__line {
    background-color: @kk-color-gold;
  }

  &__arrowhead {
    width: 1rem;
    position: relative;
    background-color: @kk-color-gold;
    height: @kk-arrow-height;
  }
  &__start &__arrowhead {
    background-color: @kk-color-primary-blue;
  }

  &__triangle {
    right: 0px;
    border-top: 5px solid transparent;
    border-left: 5px solid @kk-color-gold;
    border-bottom: 5px solid transparent;
    transform: translate(100%, calc(-50% + @kk-arrow-height / 2));
  }

  &__reverse &__triangle {
    border: none;
    right: unset;
    left: 0px;
    border-top: 5px solid transparent;
    border-right: 5px solid @kk-color-gold;
    border-bottom: 5px solid transparent;
    transform: translate(-100%, calc(-50% + @kk-arrow-height / 2));
  }
  &__start:not(&__reverse) &__triangle {
    border-left-color: @kk-color-primary-blue;
  }
  &__reverse&__start &__triangle {
    border-right-color: @kk-color-primary-blue;
  }
}
</style>
